(function () {

    'use strict';

    angular
        .module('glossaryTermEditModule')
        .controller('GlossaryTermEditController', Controller);

    Controller.$inject = ['$scope', 'topBarService', 'glossaryTerm'];

    function Controller($scope, topBarService, glossaryTerm) {

        topBarService.setTitleAndIcon('Edit Glossary Term', 'fa fa-university');
        $scope.glossaryTerm = glossaryTerm;
        
    }
})();